import { render, staticRenderFns } from "./electromagnetic_membrane.vue?vue&type=template&id=72d94dc6&scoped=true"
import script from "./electromagnetic_membrane.vue?vue&type=script&lang=js"
export * from "./electromagnetic_membrane.vue?vue&type=script&lang=js"
import style0 from "./electromagnetic_membrane.vue?vue&type=style&index=0&id=72d94dc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d94dc6",
  null
  
)

export default component.exports